import type { OwnerStateThemeType } from '.';

const Fab = () => {
  return {
    MuiFab: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          boxShadow: theme.shadows[24],
        }),
      },
    },
  };
};

export default Fab;
